/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_Faq_Q4Inputs */

const en_guide_json_schema_faq_q4 = /** @type {(inputs: Guide_Json_Schema_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I generate a schema from existing JSON?`)
};

const ko_guide_json_schema_faq_q4 = /** @type {(inputs: Guide_Json_Schema_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기존 JSON에서 스키마를 생성할 수 있나요?`)
};

const ja_guide_json_schema_faq_q4 = /** @type {(inputs: Guide_Json_Schema_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既存の JSON からスキーマを生成できますか?`)
};

/**
* | output |
* | --- |
* | "Can I generate a schema from existing JSON?" |
*
* @param {Guide_Json_Schema_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_faq_q4 = /** @type {((inputs?: Guide_Json_Schema_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_faq_q4(inputs)
	if (locale === "ko") return ko_guide_json_schema_faq_q4(inputs)
	return ja_guide_json_schema_faq_q4(inputs)
});